import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CommonDtoKeysEnum } from '@zaoblako/shared/common/enums/common-dto-keys.enum';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';

import * as yup from 'yup';

/** Common IDs' filters query parameters */
export interface IdsQueryInterface {
  /** Omit entities with these IDs */
  excludeIds?: number[];
  /** Include entities with these IDs */
  includeIds?: number[];
}

/** Common IDs' filters query parameters - DTO schema */
export const IdsQueryDto = SerdeDtoClass.create(CommonDtoKeysEnum.IDS_QUERY_DTO, {
  excludeIds: {
    optional: true,
    label: 'Исключить объекты с номерами',
    serializer: yup.array(idLikeSchema),
  },
  includeIds: {
    optional: true,
    label: 'Включить объекты с номерами',
    serializer: yup.array(idLikeSchema),
  },
});
